import React, {Component, PropTypes} from 'react'
import i18n from '../i18n'
import style from './Loader.less'

class Loader extends Component {
    static propTypes = {
    }

    render() {
        return (
            <div className={style.default}>
                <span>{i18n.loading} ...</span>
            </div>
        )
    }
}

export default Loader


// WEBPACK FOOTER //
// ./lib/core/components/Loader.js